import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";

const actions = {
  getLabels({ commit }, payload) {
    return api.fetchFull(endpoints.LABELS, payload, commit, (response) => {
      return response;
    });
  },

  getLabelByUuid({ commit }, payload) {
    return api.fetchFull(endpoints.LABELS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  createLabel({ commit }, payload) {
    return api.post(endpoints.LABELS, payload, commit, (response) => {
      return response;
    });
  },

  updateLabel({ commit }, payload) {
    return api.put(endpoints.LABELS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  deleteLabel({ commit }, payload) {
    return api.remove(endpoints.LABELS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },
};

export default actions;
